<template>
  <div>
    <!-- Table dialog servicios -->
    <el-dialog
      :title="title"
      :visible="isVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :fullscreen="false"
      top="5vh"
      width="700px"
      center
    >
      <el-form :model="data">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Nombre">
              <el-input v-model="data.name" size="small" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Codigo del Servicio">
              <el-input v-model="data.service" size="small" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24" v-if="!id" style="margin-bottom:18px;">
          <el-col :span="24">
            <el-form-item label="Paqueteria"> </el-form-item>
          </el-col>
          <el-col :span="24" style="margin-top:-15px">
            <el-select
              style="width:100%;"
              v-model="data.carrier"
              placeholder="Paqueteria"
              size="small"
              clearable
            >
              <el-option
                v-for="carrier in carriers"
                :key="carrier.value"
                :label="carrier.label"
                :value="carrier.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>

        <el-card>
          <div style="display:flex;">
            <el-upload
              class="upload-demo"
              action="#"
              :before-upload="handleFileUpload"
              style="margin-right:10px;"
            >
              <el-button size="small" type="primary"
                >Códigos Fuera de Área por CSV (Area)</el-button
              >
            </el-upload>
            <div class="el-upload__tip">
              Solo archivos CSV son permitidos
            </div>
          </div>
        </el-card>

        <el-card>
          <el-collapse v-model="expandedPickup">
            <el-collapse-item>
              <template slot="title">
                Colapsar
              </template>
              <el-row :gutter="20">
                <el-col :span="12">
                  <label class="el-form-item__label">
                    <i class="el-icon-user"></i> Fuera de Área
                  </label>
                  <el-input
                    style="margin: 7px 0px 15px 0px;"
                    type="textarea"
                    :autosize="{ minRows: 10, maxRows: 10 }"
                    placeholder="Ingrese códigos postales por linea"
                    v-model="outOfArea"
                  >
                  </el-input>

                  <el-row>
                    <el-button
                      @click="handleRemoveClient"
                      type="danger"
                      size="mini"
                      round
                      plain
                      ><i class="el-icon-minus"></i> Quitar</el-button
                    >
                    <el-button
                      @click="handleAddClient"
                      type="success"
                      size="mini"
                      round
                      plain
                      ><i class="el-icon-plus"></i> Agregar</el-button
                    >
                    <el-button
                      @click="resetArea"
                      type="warning"
                      size="mini"
                      round
                      plain
                      ><i class="el-icon-delete"></i> Resetear</el-button
                    >
                  </el-row>
                </el-col>

                <el-col :span="10">
                  <label class="el-form-item__label"
                    >Códigos Postales Actuales:
                    <b>{{ data.outOfArea.length }}</b></label
                  >
                  <pre
                    style="display: inline-block; height: 200px; margin: 7px 0px 15px 0px; width: 100%;"
                    >{{ data.outOfArea }}</pre
                  >
                </el-col>
              </el-row>
            </el-collapse-item></el-collapse
          >
        </el-card>

        <el-card>
          <div style="display:flex;">
            <el-upload
              class="upload-demo"
              action="#"
              :before-upload="handleFileUploadPickup"
              style="margin-right:10px;"
            >
              <el-button size="small" type="primary"
                >Códigos Fuera de Recolección por CSV (Pickup)</el-button
              >
            </el-upload>
            <div class="el-upload__tip">
              Solo archivos CSV son permitidos
            </div>
          </div>
        </el-card>

        <el-card>
          <el-collapse v-model="expandedPickup">
            <el-collapse-item>
              <template slot="title">
                Colapsar
              </template>
              <el-row :gutter="20">
                <el-col :span="12">
                  <label class="el-form-item__label">
                    <i class="el-icon-user"></i> Fuera de Recolección
                  </label>
                  <el-input
                    style="margin: 7px 0px 15px 0px;"
                    type="textarea"
                    :autosize="{ minRows: 10, maxRows: 10 }"
                    placeholder="Ingrese códigos postales por linea"
                    v-model="outOfPickup"
                  >
                  </el-input>

                  <el-row>
                    <el-button
                      @click="handleRemoveClientPickup"
                      type="danger"
                      size="mini"
                      round
                      plain
                      ><i class="el-icon-minus"></i> Quitar</el-button
                    >
                    <el-button
                      @click="handleAddClientPickup"
                      type="success"
                      size="mini"
                      round
                      plain
                      ><i class="el-icon-plus"></i> Agregar</el-button
                    >
                    <el-button
                      @click="resetPickup"
                      type="warning"
                      size="mini"
                      round
                      plain
                      ><i class="el-icon-delete"></i> Resetear</el-button
                    >
                  </el-row>
                </el-col>

                <el-col :span="10">
                  <label class="el-form-item__label"
                    >Códigos Postales Actuales:
                    <b>{{ data.outOfPickup.length }}</b></label
                  >
                  <pre
                    style="display: inline-block; height: 200px; margin: 7px 0px 15px 0px; width: 100%;"
                    >{{ data.outOfPickup }}</pre
                  >
                </el-col>
              </el-row>
            </el-collapse-item></el-collapse
          >
        </el-card>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="success"
          icon="el-icon-check"
          @click="handleSave"
          round
        >
          Guardar
        </el-button>
      </span>
    </el-dialog>
    <!-- END Table dialog services -->
  </div>
</template>

<script>
import { CSApi } from "@/libraries/api";
import { stringLinesToArray, getDiference, unique } from "@/utils";

export default {
  name: "DialogService",
  components: {},
  props: ["id", "carriersLit", "isVisible"],
  data() {
    return {
      expandedPickup: false,
      expandedArea: false,
      outOfArea: "",
      outOfPickup: "",
      title: "",
      max_weight: {},
      data: {
        outOfArea: [],
        outOfPickup: [],
      },
      services: [],

      carriers: this.carriersLit.map((carrierItem) => ({
        value: carrierItem.carrier,
        label: carrierItem.carrier,
      })),

      editDialogService: false,
    };
  },
  watch: {
    async isVisible() {
      // Set Carriers to select
      let arrSelectCarriers = [];

      this.carriersLit.forEach((item) => {
        if (
          !arrSelectCarriers.find((arrItem) => arrItem.value === item.carrier)
        )
          arrSelectCarriers.push({
            value: item.carrier,
            label: item.carrier,
          });
      });

      this.carriers = arrSelectCarriers;

      // Action
      if (this.id) {
        // Edit
        let recordToEdit = this.carriersLit.find(
          (service) => service.uuid === this.id
        );

        if (recordToEdit) {
          this.outOfArea = "";
          this.outOfPickup = "";
          this.data = {
            name: recordToEdit.name,
            service: recordToEdit.service,
            carrier: recordToEdit.carrier,
            outOfArea: recordToEdit.outOfArea,
            outOfPickup: recordToEdit.outOfPickup,
          };

          this.title = `${this.data.carrier}`;
        }
      } else {
        // Create
        this.data = {
          name: "",
          service: "",
          carrier: "FEDEX",
          outOfArea: [],
          outOfPickup: [],
        };

        this.title = `Nuevo Servicio`;

        const response = await CSApi().get(
          `coverage/service?searchBy=&page=1&pageSize=500`
        );
        const { data } = response.data;
        this.services = data.filter((service) => service.countryCode == "MX");
      }
    },
  },

  methods: {
    async handleSave() {
      let options = {
        message: "Se guardaron los cambios con exito.",
        type: "success",
        duration: 4000,
      };

      try {
        const body = {
          service: this.data?.service?.toUpperCase(),
          name: this.data?.name,
          outOfArea: this.data.outOfArea,
          outOfPickup: this.data.outOfPickup,
        };

        if (!this.id) {
          body.carrier = this.data?.carrier.toUpperCase();
        }

        const response = this.id
          ? await CSApi().put(`/coverage/service/${this.id}`, body)
          : await CSApi().post(`/coverage/service`, body);

        // If error
        if (!response?.data?.success)
          throw response?.data?.data?.error?.message || "Error";

        // If success
        this.update();
        this.handleClose();
      } catch (error) {
        options.showClose = true;
        options.message = error;
        options.type = "error";
      } finally {
        this.$message(options);
      }
    },

    handleClose() {
      this.$emit("close");
    },

    update() {
      this.$emit("update");
    },

    handleRemoveClient() {
      const outOfArea = stringLinesToArray(this.outOfArea);
      this.data.outOfArea = getDiference({
        source: this.data.outOfArea,
        toRemove: outOfArea,
      });
    },

    handleAddClient() {
      const outOfArea = stringLinesToArray(this.outOfArea);
      this.data.outOfArea = unique([...outOfArea, ...this.data.outOfArea]);
    },

    resetArea() {
      this.data.outOfArea = [];
    },

    resetPickup() {
      this.data.outOfPickup = [];
    },

    async handleFileUpload(file) {
      const csvData = await this.readCSV(file);
      // Asigna los datos del archivo CSV a los campos correspondientes
      this.outOfArea = (csvData.outOfArea || [])
        .filter((p) => typeof p == "string")
        .join(",");
    },
    async readCSV(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const csvData = event.target.result;
          const rows = csvData.split("\n");
          const outOfArea = [];
          rows.slice(1).forEach((row) => {
            const postalCode = row.split(",")[rows[0].indexOf("postalCode")];
            if (
              postalCode &&
              postalCode.length > 4 &&
              typeof postalCode == "string"
            )
              outOfArea.push(postalCode.toString());
          });
          resolve({ outOfArea });
        };
        reader.onerror = (error) => reject(error);
        reader.readAsText(file);
      });
    },

    handleRemoveClientPickup() {
      const outOfPickup = stringLinesToArray(this.outOfPickup);
      this.data.outOfPickup = getDiference({
        source: this.data.outOfPickup,
        toRemove: outOfPickup,
      });
    },

    handleAddClientPickup() {
      const outOfPickup = stringLinesToArray(this.outOfPickup);
      this.data.outOfPickup = unique([
        ...outOfPickup,
        ...this.data.outOfPickup,
      ]);
    },

    async handleFileUploadPickup(file) {
      const csvData = await this.readCSVPickup(file);
      // Asigna los datos del archivo CSV a los campos correspondientes
      this.outOfPickup = (csvData.outOfPickup || [])
        .filter((p) => typeof p == "string")
        .join(",");
    },
    async readCSVPickup(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const csvData = event.target.result;
          const rows = csvData.split("\n");
          const outOfPickup = [];
          rows.slice(1).forEach((row) => {
            const postalCode = row.split(",")[rows[0].indexOf("postalCode")];
            if (
              postalCode &&
              postalCode.length > 4 &&
              typeof postalCode == "string"
            )
              outOfPickup.push(postalCode.toString());
          });
          resolve({ outOfPickup });
        };
        reader.onerror = (error) => reject(error);
        reader.readAsText(file);
      });
    },
  },
};
</script>

<style>
.el-select-dropdown__item {
  padding: 10px 20px;
  height: 55px;
  width: 330px;
}
.el-form-item__label {
  font-size: 14px;
  font-weight: 100;
  line-height: 14px;
}
.el-switch__label * {
  line-height: 1;
  font-size: 14px;
  font-weight: 100;
}
.el-input .el-input--small .el-input--suffix {
  width: 260px;
}
</style>
